import { Button, CircularProgress, Grid } from '@mui/material';
import PropTypes from 'prop-types';

export default function WizardButtons({
  nextStep,
  previousStep,
  loading,
  nextLabel,
  nextLabelButtonType,
  ...rest
}) {
  const { currentStep } = rest;
  return (
    <Grid container justifyContent="space-between" marginTop={2}>
      <Grid item>{currentStep !== 1 && <Button onClick={previousStep}>Previous</Button>}</Grid>
      <Grid item>
        <Button type={nextLabelButtonType} onClick={nextStep} disabled={loading}>
          {loading ? <CircularProgress size={20} /> : <div>{nextLabel}</div>}
        </Button>
      </Grid>
    </Grid>
  );
}

WizardButtons.propTypes = {
  nextStep: PropTypes.func,
  previousStep: PropTypes.func,
  nextLabel: PropTypes.string,
  loading: PropTypes.bool,
  nextLabelButtonType: PropTypes.string,
};

WizardButtons.defaultProps = {
  nextStep: () => {},
  previousStep: () => {},
  nextLabel: 'Next',
  loading: false,
  nextLabelButtonType: '',
};
